export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return unescape(c.substring(name.length, c.length));
    }
  }
  return "";
}

export function setCookie(cname, cvalue, _exdays) {
  var d = new Date();
 
  d.setTime(d.getTime() + 1 * 3600 * 1000); // expires in 1 hour now.
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + escape(cvalue) + ";" + expires + ";path=/";
}

export function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
}

window.Cookie = {
  getCookie: getCookie,
  setCookie: setCookie
};
